import { LogoSubtitle, LogoTitle, StyledLogo } from './styles';
import { Link } from 'react-router-dom';
import logoImage from './logo.png'; // Import the logo image

interface Props {
  mode?: string
}

export default function Logo({ mode }: Props) {
  return (
    <StyledLogo mode={mode}>
      <Link to="/collections">
        <img src={logoImage} alt="Logo" /> {/* Include the logo image */}
        <LogoTitle>FOTR Collection</LogoTitle>
      </Link>
      <LogoSubtitle></LogoSubtitle>
    </StyledLogo>
  )
}
